import store from '~/store'

export default async (to, from, next) => {
  if (!store.getters['courses/terms']) {
    try {
      await store.dispatch('courses/fetchTerms')
    } catch (e) { }
  } else {
    // throw an error message
    console.log('Error: no terms')
  }

  if (store.getters['courses/term'] && (store.getters['courses/department'] || store.getters['courses/subject'])) {
    try {
	    await store.dispatch('courses/fetchCourses')
    } catch (e) { }
  } else {
  	// throw an error message
    if (!store.getters['courses/term']) {
      console.log('Error: no term set')
    } else {
      console.log('Error: no department')
    }
    
  }

  next()
}



// WEBPACK FOOTER //
// /resources/js/middleware/load-courses.js